import { getFetchedDataPayload } from '@vista-digital/utilities';
import { salesDataDomainStore } from '../../store';
export const getTicketTypeById = (ticketTypeId) => {
    const ticketType = getFetchedDataPayload(salesDataDomainStore.data.ticketTypesById[ticketTypeId]);
    if (!ticketType)
        throw new Error(`Could not find ticket type with id ${ticketTypeId}`);
    return ticketType;
};
//# sourceMappingURL=get-ticket-type-by-id.js.map